import { Align, History, Indentations, Lists, TextFormatting } from './components';

type ToolbarPluginProps = {
  disabled: boolean;
};

export const ToolbarPlugin = ({ disabled }: ToolbarPluginProps) => {
  return (
    <div className="flex items-center overflow-x-auto gap-6 p-2 sticky top-0 shadow-md bg-white rounded-t-[10px]">
      <History disabled={disabled} />
      <TextFormatting disabled={disabled} />
      <Align disabled={disabled} />
      <Indentations disabled={disabled} />
      <Lists disabled={disabled} />
    </div>
  );
};
